import React, { Fragment, useState, useEffect } from "react";
import { CheckBoxInput } from "../../../Buttons";
import { FaEdit, FaTimes, FaTrash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { setOrderRowDisabledAt } from "../../../../../redux/Actions/orderAction";
import { Input, Tooltip, message } from "antd";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { selectedOrderRows } from "../../../../../redux/Actions/orderRowAction";
import { prettyDateFormat } from "../../../../../helpers/Utils";
import { useSelector } from "react-redux";
import { have_product_reference } from "../../../../../helpers/OrdersFunctionsGlobal";
import { setCodSelected } from "../../../../../redux/Actions/orderAction";

function RowsInShipment({
  form_type,
  order_rows,
  orderRowsChange,
  isReturn = false,
  responseData,
  setResponseData,
  order_type
}) {
  const [rowsWithSelected, setRowsWithSelected] = useState([]);
  useEffect(() => {
    const rowsWithSelected = order_rows?.map((row) => {
      if (!row.hasOwnProperty("selected")) {
        return {
          ...row,
          selected: row.disabled_at ? false : true,
        };
      }
      return row;
    });
    setRowsWithSelected(rowsWithSelected);
  }, [order_rows]);

  const or_quantity_manual = useSelector(
    (state) => state.orders.or_quantity_manual
  );

  return (
    <Fragment>
      <span style={{ fontWeight: "400" }}>
        <table className="table table-sm">
          <tbody>
            {rowsWithSelected?.map((order_row, index) => {
              return (
                <OrderRowRender
                  key={index}
                  order_row={order_row}
                  responseData={responseData}
                  setResponseData={setResponseData}
                  or_quantity_manual={or_quantity_manual}
                  orderRowsChange={orderRowsChange}
                  form_type={form_type}
                  isReturn={isReturn}
                  order_type={order_type}
                />
              );
            })}
          </tbody>
        </table>
      </span>
    </Fragment>
  );
}

const OrderRowRender = ({
  order_row,
  or_quantity_manual,
  orderRowsChange,
  form_type,
  isReturn,
  setResponseData,
  order_type
}) => {
  const e = order_row;

  const dispatch = useDispatch();
  const totals = e?.shipment_order_rows?.reduce(
    (cur, acc) =>
      (acc.deleted_at || acc.canceled_at
        ? 0
        : acc.quantity || Math?.floor(acc.order_row?.quantity)) + cur,
    0
  );
  const sor_total = Math?.floor(e?.quantity) - totals;

  const setDisabledOrderRow = async (
    item_id,
    order_id,
    disabled_at,
    shipment_order_row = null,
    params = {}
  ) => {
    if (
      confirm(
        disabled_at
          ? "Are you sure want to mark the product as shipped?"
          : "Are you sure want to unmark the product as shipped?"
      )
    ) {
      const { ok, data } = await dispatch(
        setOrderRowDisabledAt(
          {
            disabled_at: disabled_at ? new Date() : null,
            shipment_order_row,
            ...params,
            form_type,
          },
          order_id,
          item_id
        )
      );


      if (ok) {
        setResponseData(data?.order_rows);
        dispatch({
          type: "UPDATE_OR_QUANTITY_MANUAL",
          payload: { [item_id]: "" },
        });
        if (data && !!orderRowsChange)
          orderRowsChange({ type: "UPDATE_ITEM", data });
      }
    }
  };

  const renderCheckBox = (item, disabled_at) => {
    if (item?.disabled_at && item?.selected == false) {
      return (
        <div className="d-block">
          <label
            className="ant-checkbox-wrapper cursor-pointer"
            onClick={() => {
              if (!disabled_at) return message?.error("You have no quantities");
              setDisabledOrderRow(item?.id, item?.order_id, !disabled_at);
            }}
          >
            <span className="ant-checkbox" style={{ top: 0 }}>
              <span className="ant-checkbox-inner d-flex justify-content-center align-items-center">
                <FaTimes color={disabled_at ? "#ff9e00" : "#d83b3b"} />
              </span>
            </span>
          </label>
        </div>
      );
    }
    return (
      <CheckBoxInput
        checked={!!item?.selected}
        onChange={() => {
          if (orderRowsChange) {
            orderRowsChange({
              type: "UPDATE_SELECTED",
              data: {
                order_row_id: item?.id,
                selected: !item?.selected,
              },
            });
          } else {
            dispatch(selectedOrderRows(item?.id, item?.order_id));
          }
        }}
      />
    );
  };
  const isCodSelected = useSelector((state) => state?.orders.isCodSelected);
  React.useEffect(() => {
    dispatch(setCodSelected(false));
    return () => {
      dispatch(setCodSelected(false));
    };
  }, []);
  return (
    <Fragment>
      <tr>
        <td className="align-middle text-center">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: 32 }}
          >
            {renderCheckBox(e, sor_total > 0)}
          </div>
        </td>
        <td className="align-middle text-center">
          <span className="px-1">
            {have_product_reference(e?.product_reference) ? (
              e?.product_reference
            ) : (
              <AiOutlineCheckCircle
                className={`text-${e?.parent_id ? "success" : "danger"}`}
              />
            )}
          </span>
        </td>
        <td className="align-middle text-center">
          {or_quantity_manual?.[e?.id] ? (
            <div className="d-flex align-items-center">
              <Input
                style={{
                  maxWidth: or_quantity_manual[e?.id].toString().length * 50,
                  borderColor: or_quantity_manual[e?.id] > Math.floor(e?.quantity) ? '#ff4d4f' : undefined,
                }}
                size="small"
                placeholder={e?.quantity}
                value={or_quantity_manual[e?.id]}
                onChange={(val) => {
                  const enteredValue = parseInt(val.target.value) || 0;
                  const maxQuantity = Math.floor(e?.quantity);
                  const validatedValue = Math.min(Math.max(enteredValue, 0), maxQuantity);

                  dispatch({
                    type: "UPDATE_OR_QUANTITY_MANUAL",
                    payload: { [e?.id]: validatedValue },
                  });
                }}
              />
              <FaTimes
                className="ml-2 mr-1 cursor-pointer"
                color="#ff9e00"
                onClick={() =>
                  dispatch({
                    type: "UPDATE_OR_QUANTITY_MANUAL",
                    payload: { [e?.id]: "" },
                  })
                }
              />
            </div>
          ) : (
            <div className="d-flex align-items-center">
              {totals}/{Math.floor(e?.quantity)}
              {sor_total > 0 && (
                <FaEdit
                  className="ml-2 mr-1 cursor-pointer"
                  color="#ff9e00"
                  onClick={() =>
                    dispatch({
                      type: "UPDATE_OR_QUANTITY_MANUAL",
                      payload: {
                        [e?.id]: +sor_total,
                      },
                    })
                  }
                />
              )}
            </div>
          )}
        </td>
        <td className="align-middle">
          <div>{e?.product_name}</div>
        </td>
        <td className="align-middle text-center">
          {/* {!e?.order_cart_rule_id && (
            <div className="text-success">Discount applied</div>
          )} */}
          <span style={{ whiteSpace: "nowrap" }}>
            {Number(e?.unit_price_tax_incl)?.toFixed(2) || 0} &#8364;
          </span>
        </td>
        <td className="align-middle text-center">
          {!orderRowsChange && !e?.disabled_at && (
            <div>
              <Tooltip placement="top" title="Marked product as shipped">
                <AiOutlineCheckCircle
                  className={"text-danger cursor-pointer ml-1"}
                  onClick={() =>
                    isCodSelected
                      ? message?.error("Shipment is with COD")
                      : setDisabledOrderRow(e?.id, e?.order_id, true, null, {
                        manual_quantity: or_quantity_manual[e?.id] || null,
                      })
                  }
                />
              </Tooltip>
            </div>
          )}
        </td>
      </tr>
      {!isReturn && (
        <FilterRowHistory
          order_row_histories={e?.shipment_order_rows}
          setDisabledOrderRow={(shipment_order_row, order_quantity) =>
            setDisabledOrderRow(
              e?.id,
              e?.order_id,
              order_quantity - sor_total <= 0 ? true : false,
              shipment_order_row
            )
          }
          form_type={form_type}
          order_type={order_type}
        />
      )}

      {e?.childs?.map((d) => (
        <OrderRowRender
          key={d.id}
          e={d}
          order_row={d}
          or_quantity_manual={or_quantity_manual}
          orderRowsChange={orderRowsChange}
          form_type={form_type}
          isReturn={isReturn}
          order_type={order_type}
        />
      ))}
    </Fragment>
  );
};

const FilterRowHistory = ({ order_row_histories, setDisabledOrderRow, form_type, order_type }) => {
  const prettierStatus = (shipment, amount, its_fake) => {
    return (
      <span>
        <div>Quantity shipped: {amount}</div>
        <div>
          <b>
            {its_fake ? (
              "Mark product as shipped"
            ) : (
              <Fragment>
                <span>
                  Shipments:
                  {/* {shipment} */}
                </span>
                {shipment?.map((title, idx) => (
                  <span>
                    {title}
                    {idx == shipment?.length - 1 ? "" : ", "}
                  </span>
                ))}
              </Fragment>
            )}
          </b>
        </div>
      </span>
    );
  };

  return order_row_histories?.map((e, idx) => {
    const check = () => {
      return e?.deleted_at || e?.canceled_at;
    };
    const checkButton = () => {
      return !check();
    };
    return (
      <tr
        key={idx}
        style={{
          borderLeft: "1px solid #a8e2df",
        }}
      >
        <td className="pl-3 pr-0 py-0 align-middle" colSpan={3}>
          {check() ? (
            <del>
              <small>
                {prettierStatus(
                  e?.tracking_numbers,
                  e?.quantity || Math?.floor(e?.order_row?.quantity),
                  e?.title == "FAKE" || e?.fake == true
                )}
              </small>
            </del>
          ) : (
            <div className="d-flex align-items-center">
              {checkButton() && form_type !== "ProductTransfer" && order_type !== "ProductTransfer" && (
                <Tooltip placement="top" title="Mark product as not shipped">
                  <FaTrash
                    className={"text-danger cursor-pointer mr-1"}
                    onClick={() =>
                      setDisabledOrderRow(
                        e?.id,
                        +e?.quantity || Math?.floor(e?.order_row?.quantity)
                      )
                    }
                  />
                </Tooltip>
              )}
              <small>
                {prettierStatus(
                  e?.tracking_numbers,
                  e?.quantity || Math?.floor(e?.order_row?.quantity),
                  e?.title == "FAKE" || e?.fake == true
                )}
              </small>
            </div>
          )}
        </td>
        <td className="p-0 align-middle text-center" colSpan={1}>
          {check() ? (
            <del>
              <div>
                <small>
                  {e?.canceled_user && "Created by: "}
                  {e?.user_title}
                </small>
              </div>
              {e?.canceled_user && (
                <div className="text-danger">
                  <small>Canceled by: {e?.canceled_user}</small>
                </div>
              )}
            </del>
          ) : (
            <small>{e?.user_title}</small>
          )}
        </td>
        <td className="p-0 align-middle text-center" colSpan={2}>
          <div className="d-flex justify-content-end align-items-center">
            {check() ? (
              <del>
                <div>
                  <small>
                    {e?.canceled_at && "Sukurta: "}
                    {prettyDateFormat(e?.created_at)}
                  </small>
                </div>
                {e?.canceled_at && (
                  <div className="text-danger">
                    <small>
                      Canceled by: {prettyDateFormat(e?.canceled_at)}
                    </small>
                  </div>
                )}
              </del>
            ) : (
              <small>{prettyDateFormat(e?.created_at)}</small>
            )}
          </div>
        </td>
      </tr>
    );
  });
};

export default RowsInShipment;
